import { apiUrls } from "../../services/config";

export default function MyAccountLoginButton() {
  return (
    <a href={`${apiUrls.myAccount}`} className="button button--primary">
      Log in to My Account
    </a>
  );
}
